import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { Meta } from '~/Actions/ActionApplications';
import type { IApiAutocompleteResponse, IApiError } from '~/types/api';
import type { ClanSearchAutocompleteItem } from '~/types/declaration';
import type { Nullable } from '~/types/generics';

type IApiAutocompleteResponseExtended = IApiAutocompleteResponse & {
  term: string;
};

export type AutocompleteState = {
  error: IApiError | null;
  foundByTerm: string;
  isFetching: boolean;
  items: ClanSearchAutocompleteItem[];
  meta: Nullable<Meta>;
};

const initialState: AutocompleteState = {
  error: null,
  foundByTerm: '',
  isFetching: false,
  items: [],
  meta: null,
};

const autocompleteSlice = createSlice({
  name: 'autocomplete',
  initialState,
  reducers: {
    clearResult(state) {
      state.items = [];
      state.isFetching = false;
      state.foundByTerm = '';
    },

    clearAutocompleteState() {
      return initialState;
    },

    startFetching(state) {
      state.isFetching = true;
      state.foundByTerm = '';
    },

    processFailedResponse(state, action: PayloadAction<IApiError>) {
      state.isFetching = false;
      state.items = [];
      state.meta = null;
      state.error = action.payload;
      state.foundByTerm = '';
    },

    processSuccessfulResponse(state, action: PayloadAction<IApiAutocompleteResponseExtended>) {
      state.isFetching = false;
      state.items = action.payload.search_autocomplete_result;
      state.meta = action.payload._meta_;
      state.error = null;
      state.foundByTerm = action.payload.term;
    },
  },
});

export const autocompleteActions = autocompleteSlice.actions;
export default autocompleteSlice.reducer;
